import React, { useEffect, useState } from "react";
import {
  addPayableMajorHead,
  addPayableMinorHead,
  addReceivableMajorHead,
  addReceivableMinorHead,
  checkMajorHeadId,
  checkPayableMajorHeadId,
  checkPayableMinorID,
  checkReceivableMajorID,
  checkReceivableMinorID,
  getHeads,
  getMajorheads,
  getMajorheadsForReceivable,
  getMinorheads,
  getMinorheadsForReceivable,
  updatePayableMajorHead,
  updatePayableMinorHead,
  updateReceivableMajorHead,
  updateReceivableMinorHead,
} from "../../api/User";
import { Modal, Button } from "react-bootstrap";
import { MdEdit } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { IoMdAdd } from "react-icons/io";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function PaymentExpenditure({ token,userDetail, userData }) {
  const [headType, setHeadType] = useState("pay");
  const [heads, setHeads] = useState([]);
  const [error, setError] = useState("");
  const [button, setButton] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalHeads, setModalHeads] = useState([]);
  const [modalMinor, setModalMinor] = useState([]);
  const [selected, setSelected] = useState("");
  const [isEdit, setIsEdit] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [idAvail, setIdAvail] = useState(false);
  const [minorHeadId, setMinorHeadId] = useState("");
  const [minorHeadName, setMinorHeadName] = useState("");
  const [majorHeadId, setMajorHeadId] = useState("");
  const [majorHeadName, setMajorHeadName] = useState("");
  const MySwal = withReactContent(Swal);
  const [addNewMajor, setAddNewMajor] = useState(false);
  const [majorName, setMajorName] = useState("");
  const [majorId, setMajorId] = useState("");
  const [isMajorVisible, setIsMajorVisible] = useState(false);
  const [isButton, setIsButton] = useState(true);
  const [isMajorHeadVisible, setIsMajorHeadVisible] = useState(false);
  const role = userDetail.role_id

  useEffect(() => {
    const fetchHeads = async () => {
      try {
        const response = await getHeads(token, { head_type: headType });
        setHeads(response.data);
      } catch (err) {
        setError("Failed to fetch heads.");
      }
    };


    fetchHeads();
  }, [headType, token]);

  const handleHeadTypeChange = (e) => {
    const { value } = e.target;
    setHeadType(value);
    setButton(value == "pay" ? true : false);
  };

  const handleExpendibleHeads = () => {
    setShowModal(true);
    getMajorheads(token).then((res) => {
      if (res.status == "success") {
        setModalHeads(res.data);
      }
    });
  };

  const handleReceivableHeads = () => {
    setShowModal(true);
    getMajorheadsForReceivable(token).then((res) => {
      if (res.status == "success") {
        setModalHeads(res.data);
      }
    });
  };

  const handleMajorHeads = (e) => {
    setIsMajorHeadVisible(true);
    const { value } = e.target;
    const data = value.split("+");
    setMajorHeadId(data[0]);
    setMajorHeadName(data[1]);
    setIsVisible(true);
    button
      ? getMinorheads(token, { major_head: data[0] }).then((res) => {
          if (res.status == "success") {
            setModalMinor(res.data);
          }
        })
      : getMinorheadsForReceivable(token, { major_head: data[0] }).then(
          (res) => {
            if (res.status == "success") {
              setModalMinor(res.data);
            }
          }
        );
  };

  const handleMinorChange = (id, e) => {
    const data = {
      major_id: majorHeadId,
      minor_id: id,
      minor_head: e.target.value,
    };
    button
      ? updatePayableMinorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsVisible(false);
            setSelected("");
            setIdAvail(false);
            setAddNew(false);
            setMinorHeadId("");
            setMinorHeadName("");
          }
        })
      : updateReceivableMinorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsVisible(false);
            setSelected("");
            setIdAvail(false);
            setAddNew(false);
            setMinorHeadId("");
            setMinorHeadName("");
          }
        });
  };

  const toggleEdit = (i) => {
    setSelected(i);
    setIsEdit(false);
  };
  const addMinorHead = () => {
    const data = {
      major_id: majorHeadId,
      major_head: majorHeadName,
      minor_id: minorHeadId,
      minor_head: minorHeadName,
    };
    button
      ? addPayableMinorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsVisible(false);
            setSelected("");
            setIdAvail(false);
            setAddNew(false);
            setMinorHeadId("");
            setMinorHeadName("");
            setIsMajorVisible(false);
          }
        })
      : addReceivableMinorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsVisible(false);
            setSelected("");
            setIdAvail(false);
            setAddNew(false);
            setMinorHeadId("");
            setMinorHeadName("");
            setIsMajorVisible(false);
          }
        });
  };
  const handleMinorId = () => {
    const data = {
      major_id: majorHeadId,
      minor_id: minorHeadId,
    };
    button
      ? checkPayableMinorID(token, data).then((res) => {
          if (res.status == "success") {
            if (res.data[0].available === 1) {
              MySwal.fire({
                icon: "error",
                title: "Error",
                text: "Minor Head ID already exists",
              });
              setMinorHeadId("");
            } else {
              setIdAvail(true);
            }
          }
        })
      : checkReceivableMinorID(token, data).then((res) => {
          if (res.status == "success") {
            if (res.data[0].available === 1) {
              MySwal.fire({
                icon: "error",
                title: "Error",
                text: "Minor Head ID already exists",
              });
            } else {
              setIdAvail(true);
            }
          }
        });
  };
  const openInput = () => {
    setAddNew(true);
  };
  const handleMajorName = (e) => {
    setMajorName(e.target.value);
    const data = {
      major_id: majorHeadId,
      major_head: e.target.value,
    };

    button
      ? updatePayableMajorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsButton(true);
            setIsMajorVisible(false);
            setIsMajorHeadVisible(false);
          }
        })
      : updateReceivableMajorHead(token, data).then((res) => {
          MySwal.fire({
            icon: res.status,
            title: res.status,
            text: res.message,
          });
          if (res.status == "success") {
            setShowModal(false);
            setIsButton(true);
            setIsMajorVisible(false);
            setIsMajorHeadVisible(false);
          }
        });
  };
  const handleMajorId = (e) => {
    const data = {
      major_id: e.target.value,
    };
    button
      ? checkPayableMajorHeadId(token, data).then((res) => {
          if (res.status == "success") {
            if (res.data[0].available === 1) {
              setMajorId("");
              MySwal.fire({
                icon: "error",
                title: "Error",
                text: "Major Head ID already exists",
              });
            }
          }
        })
      : checkReceivableMajorID(token, data).then((res) => {
          if (res.status == "success") {
            if (res.data[0].available === 1) {
              setMajorId("");
              MySwal.fire({
                icon: "error",
                title: "Error",
                text: "Major Head ID already exists",
              });
            }
          }
        });
  };
  const toggleAdd = (headName, e) => {
    setIsMajorVisible(true);
    setAddNewMajor(false);
    setIsButton(false);
  };

  const handleSave = (headName, e) => {
    const data = {
      major_id: majorId,
      major_head: majorName,
    };
    button
      ? addPayableMajorHead(token, data).then((res) => {
          if (res.status == "success") {
            MySwal.fire({
              icon: res.status,
              title: res.status,
              text: res.message,
            });
            setShowModal(false);
            setIsButton(true);
            setIsMajorVisible(false);
            setIsMajorHeadVisible(false);
          }
        })
      : addReceivableMajorHead(token, data).then((res) => {
          if (res.status == "success") {
            MySwal.fire({
              icon: res.status,
              title: res.status,
              text: res.message,
            });
            setShowModal(false);
            setIsButton(true);
            setIsMajorVisible(false);
            setIsMajorHeadVisible(false);
          }
        });
  };

  const handleAddMajorName = (e) => {
    setMajorName(e.target.value);
  };
  return (
    <>
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center"></div>

        <div className="row mb-4">
          <div className="col-4">
            <label htmlFor="type" className="form-label">
              Head Type {<span style={{ color: "red" }}>*</span>}{" "}
            </label>
            <select
              id="headType"
              value={headType}
              onChange={handleHeadTypeChange}
              className="type form-select"
            >
              <option value="pay">Payable </option>
              <option value="rec">Receivable </option>
            </select>
          </div>
          {role === 1 || role === 2 || role === 3 || role === 4 || role === 5 ? (  
          <div className="col-4 d-flex justify-content-end align-items-end">
            {button == true && (
              <button
                className="btn form-control"
                onClick={handleExpendibleHeads}
              >
                Add Payable Heads
              </button>
            )}
            {button == false && (
              <button
                className="btn form-control"
                onClick={handleReceivableHeads}
              >
                Add Receivable Heads
              </button>
            )}
          </div>
          ) : null}
        </div>


        <div className="mb-4 mt-4 col-12 d-flex justify-content-start align-items-center">
          <h5>Expenditure Heads</h5>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="table table-striped table-bordered justify-content-center align-items-center"
            aria-label="simple table"
          >
            <thead>
              <tr style={{ fontSize: "16px" }}>
                <th
                  align="center"
                  style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                >
                  S. No.
                </th>
                <th
                  align="center"
                  style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                >
                  Major Head
                </th>
                <th
                  align="center"
                  style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                >
                  Nomenclature of Major Head
                </th>
                <th
                  align="center"
                  style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                >
                  Minor Head
                </th>
                <th
                  align="center"
                  style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                >
                  Nomenclature of Minor Head
                </th>
              </tr>
            </thead>
            <tbody>
              {heads.length > 0 ? (
                heads.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.major_head}</td>
                    <td>{row.nomenclature_of_major_head}</td>
                    <td>{row.minor_head}</td>
                    <td>{row.nomenclature_of_minor_head}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" align="center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setIsVisible(false);
          setSelected("");
          setIdAvail(false);
          setAddNew(false);
          setMinorHeadId("");
          setMinorHeadName("");
          setIsButton(true);
          setIsMajorVisible(false);
          setIsMajorHeadVisible(false);
        }}
        size="xl"
        style={{ overflow: "scroll" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add and Update Heads</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "60vh" }}>
          <div className="container-fluid d-flex">
            <div className="col-6">
              <label htmlFor="majorHead" className="form-label">
                Major Head
                <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name=""
                id=""
                className="form-select"
                onChange={handleMajorHeads}
                style={{ width: "90%" }}
              >
                <option value="" disabled selected>
                  Select Major Head
                </option>
                {modalHeads?.map((item) => (
                  <option
                    value={`${item.major_head}+${item.nomenclature_of_major_head}`}
                  >
                    {item.nomenclature_of_major_head}
                  </option>
                ))}
              </select>
              {isButton && (
                <button
                  className="btn my-2 ms-1"
                  style={{ width: "8%" }}
                  onClick={(e) => toggleAdd(majorHeadName, e)}
                >
                  {addNewMajor ? <TiTick /> : <IoMdAdd />}
                </button>
              )}
              {isMajorVisible && (
                <form>
                  <div className="d-flex col mt-2">
                    <input
                      className="mb-1 form-control me-1"
                      placeholder="ID"
                      value={majorId}
                      onChange={(e) => setMajorId(e.target.value)}
                      onBlur={handleMajorId}
                      style={{ width: "15%" }}
                      required
                    />
                    <input
                      className="mb-1 form-control"
                      placeholder="Enter the Major Head Name"
                      onBlur={handleAddMajorName}
                      style={{ width: "65%" }}
                      required
                    />
                    <button
                      type="submit"
                      className="btn mb-1 ms-1"
                      style={{ width: "8%" }}
                      onClick={() => handleSave(majorHeadName)}
                    >
                      {<TiTick />}
                    </button>
                  </div>
                </form>
              )}
              {isMajorHeadVisible && (
                <div>
                  <div className="d-flex col mt-2">
                    <input
                      className="mb-1 form-control me-1"
                      placeholder={majorHeadId}
                      disabled={selected == majorHeadName ? false : true}
                      style={{ width: "15%" }}
                    />
                    <input
                      className="mb-1 form-control"
                      placeholder={majorHeadName}
                      disabled={selected == majorHeadName ? false : true}
                      onBlur={handleMajorName}
                      style={{ width: "65%" }}
                    />
                    <button
                      className="btn mb-1 ms-1"
                      style={{ width: "8%" }}
                      onClick={() => toggleEdit(majorHeadName)}
                    >
                      {selected == majorHeadName ? <TiTick /> : <MdEdit />}
                    </button>
                  </div>
                </div>
              )}
            </div>

            {isVisible && (
              <div className="col-6 d-flex row">
                <label htmlFor="majorHead" className="form-label">
                  Minor Head
                  <span style={{ color: "red" }}>*</span>
                </label>
                {modalMinor?.map((item, i) => (
                  <div key={i} className="d-flex">
                    <input
                      className="mb-1 form-control"
                      placeholder={item.nomenclature_of_minor_head}
                      disabled={selected == item.minor_head ? false : true}
                      onBlur={(e) => handleMinorChange(item.minor_head, e)}
                      style={{ width: "85%" }}
                    />
                    <button
                      className="btn mb-1 ms-1"
                      style={{ width: "8%" }}
                      onClick={() => toggleEdit(item.minor_head)}
                    >
                      {selected == item.minor_head ? <TiTick /> : <MdEdit />}
                    </button>
                  </div>
                ))}
                <div
                  className="d-flex justify-content-end"
                  style={{ width: "94%" }}
                >
                  {addNew && (
                    <input
                      className="mb-1 form-control"
                      type={idAvail ? "text" : "number"}
                      placeholder={
                        idAvail ? "Add new minor head" : "Add new minor head ID"
                      }
                      value={idAvail ? minorHeadName : minorHeadId}
                      onChange={(e) => {
                        if (idAvail) {
                          setMinorHeadName(e.target.value);
                        } else {
                          setMinorHeadId(e.target.value);
                        }
                      }}
                      maxLength={idAvail ? 50 : 5}
                      style={{ width: "91%" }}
                    />
                  )}
                  <button
                    className="btn mb-1 ms-1"
                    style={{ width: "9%" }}
                    onClick={() => {
                      if (!addNew) {
                        openInput();
                      } else {
                        if (idAvail) {
                          addMinorHead();
                        } else {
                          handleMinorId();
                        }
                      }
                    }}
                  >
                    {addNew ? <TiTick /> : <IoMdAdd />}
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PaymentExpenditure;
